/* WristBear cart: gift message saved to the cart note (debounced, flushed before checkout, keepalive),
   "Search by reference" opener for the empty cart, and the mobile sticky checkout bar. Progressive enhancement. */
(() => {
  const MAX = 150;
  let timer = null;
  let pendingEl = null;
  let typed = null; // last value typed here; restored if the cart re-renders before the save lands

  const setStatus = (el, text) => {
    const status = el.closest('.wb-gift')?.querySelector('[data-wb-gift-status]');
    if (status) status.textContent = text;
  };

  const save = (el) => {
    const note = el.value.slice(0, MAX);
    return fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note })
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.status);
        if (el.isConnected && el.value.slice(0, MAX) === note) setStatus(el, 'Saved');
      })
      .catch(() => {
        if (el.isConnected) setStatus(el, "Couldn't save your message. Please try again.");
      });
  };

  const flush = () => {
    if (!timer) return;
    clearTimeout(timer);
    timer = null;
    const el = pendingEl;
    pendingEl = null;
    if (el) save(el);
  };

  document.addEventListener('input', (e) => {
    const el = e.target.closest?.('[data-wb-gift]');
    if (!el) return;
    typed = el.value;
    const count = el.closest('.wb-gift')?.querySelector('[data-wb-gift-count]');
    if (count) count.textContent = el.value.length;
    const left = MAX - el.value.length;
    setStatus(el, left <= 20 ? `${left} characters left` : '');
    clearTimeout(timer);
    pendingEl = el;
    timer = setTimeout(flush, 500);
  });

  // Save before leaving for checkout (form submit, express buttons), a quantity change or page exit.
  document.addEventListener('submit', flush, true);
  document.addEventListener('click', (e) => {
    if (e.target.closest?.('[name="checkout"], .additional-checkout-buttons, .wb-checkout')) flush();
  }, true);
  document.addEventListener('cart:grouped-sections', flush);
  window.addEventListener('pagehide', flush);

  // A quantity change re-renders the drawer/cart body: keep what the shopper typed.
  document.addEventListener('cart:updated', () => {
    if (typed === null) return;
    document.querySelectorAll('[data-wb-gift]').forEach((el) => {
      if (el.value === typed) return;
      el.value = typed;
      const count = el.closest('.wb-gift')?.querySelector('[data-wb-gift-count]');
      if (count) count.textContent = typed.length;
      if (typed) el.closest('details')?.setAttribute('open', '');
    });
  });

  // Empty cart "Search by reference": open the header search (link falls back to /search).
  document.addEventListener('click', (e) => {
    const link = e.target.closest?.('[data-wb-open-search]');
    if (!link) return;
    const input = document.querySelector('.header__search input[type="search"]');
    if (!input) return;
    e.preventDefault();
    const open = () => {
      window.scrollTo(0, 0);
      const toggle = document.querySelector('[data-mobile-search-toggle]');
      if (toggle && toggle.offsetParent !== null) {
        if (toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
        else input.focus();
      } else {
        input.focus();
      }
    };
    const drawer = link.closest('cart-drawer');
    if (drawer && typeof drawer.hide === 'function') {
      Promise.resolve(drawer.hide()).then(() => setTimeout(open, 50));
    } else {
      open();
    }
  });
})();

/* Cart page, under 750px: sticky "Check out · total" bar, hidden while the in-flow Check out button is on screen. */
if (!customElements.get('wb-sticky-checkout')) {
  customElements.define('wb-sticky-checkout', class extends HTMLElement {
    connectedCallback() {
      const target = document.querySelector('.cart__footer--buttons .wb-checkout');
      if (!target || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(([entry]) => {
        this.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top > 0);
      });
      this.observer.observe(target);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}
